import React from 'react';
export function TelehealthConsent() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-1072">
      <section className="pt-32 pb-16 px-6" data-id="element-1073">
        <div className="container mx-auto max-w-4xl" data-id="element-1074">
          <h1 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-1075">
            <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-1076">
              Telehealth Consent
            </span>
          </h1>

          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-1077">
            <div className="space-y-6 text-gray-700 dark:text-gray-300" data-id="element-1078">
              <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl border border-gray-200 dark:border-gray-600" data-id="element-1079">
                <p className="font-semibold uppercase leading-relaxed" data-id="element-1080">
                  BY CLICKING "I AGREE," CHECKING A RELATED BOX TO SIGNIFY YOUR
                  ACCEPTANCE, USING ANY OTHER ACCEPTANCE PROTOCOL PRESENTED
                  THROUGH THE SERVICE OR OTHERWISE AFFIRMATIVELY ACCEPTING THIS
                  CONSENT, YOU ACKNOWLEDGE THAT YOU HAVE READ, ACCEPTED, AND
                  AGREED TO BE BOUND BY THIS CONSENT. IF YOU DO NOT AGREE TO
                  THIS CONSENT, DO NOT USE THE SERVICE. YOU HEREBY GRANT AGENCY
                  AUTHORITY TO ANY PARTY WHO CLICKS ON THE "I AGREE" BUTTON OR
                  OTHERWISE INDICATES ACCEPTANCE TO THIS CONSENT ON YOUR BEHALF.
                </p>
              </div>

              <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1081">
                CONSENT TO TELEHEALTH
              </h2>

              <p className="leading-relaxed" data-id="element-1082">
                Telehealth is a mode of delivering health care services via
                communication technologies to facilitate diagnosis,
                consultation, treatment, education, care management, and self
                management of a patient's healthcare. The purpose of this
                consent form ("Consent") is to provide you with information
                about telehealth and to obtain your informed consent to the use
                of telehealth in the delivery of healthcare and/or mental health
                services to you by physicians, physician assistants, nurse
                practitioners, and/or mental health professionals ("Providers")
                using the online platforms owned and/or operated by JoinOmu, Inc
                and/or its affiliates and/or subsidiaries (the "Service"). In
                this Consent, the terms "you" and "yours" refer to the person
                using the Service, or in the case of a use of the Service by or
                on behalf of an individual minor between the ages of thirteen
                (13) and eighteen (18) or higher age of majority under
                applicable state law, "you" and "yours" refer to and include (i)
                the parent or legal guardian who provides consent to the use of
                the Service by such minor or uses the Service on behalf of such
                minor, and (ii) the minor for whom consent is being provided or
                on whose behalf the Service is being utilized.
              </p>

              <p className="leading-relaxed" data-id="element-1083">
                You are reviewing and acknowledging this Telehealth Consent Form
                because you are seeking Services from JoinOmu, Inc utilizing
                telehealth technologies facilitated through the JoinOmu, Inc.
                website, web app, or any partner platform, mobile app, or web
                mobile technologies owned and/or operated by JoinOmu, Inc -
                (collectively, the "Platform"). This Telehealth Consent Form
                supplements but does not modify or supersede any Terms of Use,
                Privacy Policy, or Notice of Privacy Practices of JoinOmu, Inc.,
                or other healthcare providers offering services via the
                Platform.
              </p>

              <p className="leading-relaxed" data-id="element-1084">
                By using JoinOmu, attending telehealth visits with a provider
                assigned to you by JoinOmu, and receiving treatments facilitated
                by JoinOmu you are indicating that you have reviewed this
                Telehealth Consent Form or had it explained to you, that you
                understand the risks and limitations of using telehealth
                technologies, that you have been given the opportunity to ask
                questions and that such questions have been answered to your
                satisfaction, that you have been given the opportunity to
                exercise your opt-out rights where appropriate, and that you
                consent to receiving the Services from licensed health care
                providers employed by or contracted with JoinOmu, Inc. who are
                located at sites remote from you. If you have any questions,
                please email{' '}
                <a href="mailto:ryan@joinomu.com" className="text-[#C85A15] hover:text-[#FF8A3D] underline" data-id="element-1085">
                  ryan@joinomu.com
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}